import { action } from 'satcheljs';

export default action('SET_FAVORITES_LOADED');
